module.exports = __webpack_public_path__ + "img/symbol-y2-left.07b2ae58.png";